module.exports = __webpack_public_path__ + "static/media/construction.362b13c2.gif";